import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    retrieved: null
  },
  getters: {
    isLoading: (state) => state.isLoading,
    retrieved: (state) => state.retrieved
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setRetrieved (state, retrieved) {
      state.retrieved = retrieved
    },
    reset (state) {
      state.retrieved = null
      state.isLoading = false
    }
  },
  actions: {
    async retrieve ({ commit }, link) {
      commit('toggleLoading')
      const response = await new ApiService(link).getResults()
      commit('setRetrieved', response)
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
